<template>
  <div class="container">
    <div class="box-title" :style="{marginTop: '-15px'}">
      <h4>
        <i class="fal fa-gifts"></i>
        {{ $t('ລາຍການOrderພັດສະດຸ.ລາຍການທັງໝົດ') }}
      </h4>
    </div>

    <div class="box" style="margin-bottom: 12px;margin-top: -12px;">
      <div class="columns">
        <div class="column is-2">
          <div class="field">
            <div class="control">
              <label class="label">{{ $t('ລາຍການOrderພັດສະດຸ.ຄົ້ນຫາເລກບິນເທົ່ານັ້ນ') }}:</label>
              <input
                  class="input"
                  :placeholder="$t('ລາຍການOrderພັດສະດຸ.ເລກບິນເທົ່ານັ້ນ')"
                  type="text" name="name"
                  v-model="searchItem"
                  @keyup.enter="resetAndSearch()"
              >
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="center table-limit-height">
      <vs-table v-if="getOrdersList.length !== 0" :loading="loading">
        <template #thead>
          <vs-tr>
            <vs-th></vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ສະຖານະ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ລາຍລະອຽດບິນ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ຮູບລາຍເຊັນ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ໝາຍເຫດ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ເລກທີບິນ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ວັນທີຝາກເຄື່ອງ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ວັນທີແກ້ໄຂບິນ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ວັນທີເຄື່ອງຮອດ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ວັນທີຈັດສົ່ງສຳເລັດ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ຈຳນວນ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ນ້ຳໜັກ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ສ່ວນຫຼຸດ") }}</vs-th>
            <vs-th v-if="$route.query.tab === 'origin_freight_fees'">{{ $t("ລາຍການOrderພັດສະດຸ.ຄ່າຂົນສົ່ງຕົ້ນທາງ") }}</vs-th>
            <vs-th v-else-if="$route.query.tab === 'destination_freight_fees'">{{ $t("ລາຍການOrderພັດສະດຸ.ຄ່າຂົນສົ່ງປາຍທາງ") }}</vs-th>
            <vs-th v-else-if="$route.query.tab === 'origin_freight_fees_cod'">{{$t("ລາຍການOrderພັດສະດຸ.ຄ່າຂົນສົ່ງຕົ້ນທາງ")}}</vs-th>
            <vs-th v-else>{{ $t("ລາຍການOrderພັດສະດຸ.ຄ່າຂົນສົ່ງ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ປະກັນໄພ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ລວມຄ່າຂົນສົ່ງ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ຄ່າຕີກັບ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ຄ່າຝາກສາງ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ຄ່າສິນຄ້າ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ຊື່ຜູ້ສົ່ງ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ຊື່ຜູ້ຮັບ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ສາຂາຕົ້ນທາງ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ສາຂາປາຍທາງ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ປະເພດການຊຳລະ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ປະເພດຂົນສົ່ງ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ຜູ້ຮັບຜິດຊອບ") }}</vs-th>
            <vs-th>{{ $t("ລາຍການOrderພັດສະດຸ.ຜູ້ຈັດສົ່ງ") }}</vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              :key="index"
              v-for="(item, index) in getOrdersList">
            <vs-td style="text-align: right; width: 100px">
              <div class="group-icon">
                <!--                change sender-->
                <vs-button
                    v-if="!$can('service') && $route.query.tab !== 'all' && $route.query.tab !== 'allForCod' && item.shipment_status_id !== 3"
                    circle icon flat
                    @click="OpenModalPrint(item.shipment_number)">
                  <i class="fad fa-phone"></i>
                </vs-button>
                <!--                cancel address error-->
                <vs-button
                    v-if="$route.query.tab !== 'allForCod'   && item.shipment_status_id === 6"
                    circle icon flat
                    @click="OpenModalPreviewFile(item.shipment_number)">
                  <i class="fad fa-map-marker-check"></i>
                </vs-button>
                <!--                change reject branch (backend: auth:api + role:SuperAdmin|service)-->
                <vs-button
                    v-if="item.reject_date !== null && $can(['SuperAdmin', 'service'])"
                    circle icon flat
                    @click="OpenModalChangeRejectBranch(item.shipment_number)">
                  <i class="fad fa-exchange-alt"></i>
                </vs-button>
                <!--                update branch swap (service role only, end_branch_id = 371)-->
                <vs-button
                    v-if="$can('service') && item.end_branch_id === 371"
                    circle icon flat
                    @click="OpenModalUpdateBranchSwap(item.shipment_number)"
                    title="ຍົກເລີກມາກວດສອບການເຄື່ອນໄຫວ">
                  <i class="fad fa-sync-alt"></i>
                </vs-button>
                <!--                edit freight-->
                <vs-button v-if="!$can('service') && $route.query.tab !== 'all' && $route.query.tab !== 'allForCod'" circle icon flat
                           @click="OpenModalEdit(item.shipment_number)">
                  <i class="fad fa-pencil"></i>
                </vs-button>
                <!--                change branch or reject-->
                <vs-button v-if="$route.query.tab !== 'allForCod'
                            && item.shipment_status_id !== 8
                            && item.shipment_status_id !== 3
                            && item.reject_freight === 0"
                           circle icon flat
                           @click="OpenModalDelete(item)">
                  <i class="fad fa-house"></i>
                </vs-button>
                <!--                add cod price-->
                <vs-button
                    v-if=" !$can('service') && $route.query.tab === 'allForCod' && (item.shipment_status_id === 2 || item.shipment_status_id === 13 || item.shipment_status_id === 6)"
                    circle icon
                    flat
                    @click="OpenModalClose(item.shipment_number)">
                  <i class="fad fa-money-bill"></i>
                </vs-button>
                <!--                cancel success order-->
                <vs-button
                    v-if="$route.query.tab !== 'allForCod' && item.shipment_status_id === 3"
                    circle icon flat
                    @click="OpenModalCancel(item.shipment_number)">
                  <i class="fad fa-window-close"></i>
                </vs-button>
                <!--                cancel reject-->
                <vs-button
                    v-if="$route.query.tab !== 'allForCod'
                    && (item.shipment_status_id === 8
                    || (item.shipment_status_id === 13 && item.reject_freight !== 0))"
                    circle icon flat
                    @click="OpenModalAdd(item.shipment_number)">
                  <i class="fad fa-window-close"></i>
                </vs-button>
                <vs-button circle icon flat
                           @click="$router.push({name: 'account.list.shipment.detail', params:{id: item.id}})">
                  <i class="fad fa-eye"></i>
                </vs-button>
              </div>
            </vs-td>
            <vs-td
                v-if="item.tracking_state_id === 5 && (item.shipment_status_id === 2 || item.shipment_status_id === 6 || item.shipment_status_id === 8)">
              {{ $t("ລາຍການOrderພັດສະດຸ.ເຄື່ອງຮອດສາຂາປາຍທາງ") }}
            </vs-td>
            <vs-td v-else> {{ $t('common.' + item.shipment_status_name) }}</vs-td>
            <vs-td>{{ item.tracking }}</vs-td>
            <vs-td>
              <div v-if="item.signature_file" class="img-size">
                <expandable-image
                    class="image"
                    :src=item.signature_file
                ></expandable-image>
              </div>
            </vs-td>
            <vs-td>{{ item.remark }}</vs-td>
            <vs-td :style="{color: 'crimson'}">( {{ item.shipment_number }} )</vs-td>
            <vs-td v-if="item.shipment_status_id === 1">{{ FormatDate(item.created_at) }}</vs-td>
            <vs-td v-else>{{ FormatDate(item.start_date_actual) }}</vs-td>
            <vs-td v-if="item.shipment_status_id !== 1
            && item.shipment_status_id !== 2
            && item.shipment_status_id !== 3
            && item.shipment_status_id !== 11">{{ FormatDate(item.updated_at) }}
            </vs-td>
            <vs-td v-else></vs-td>

            <vs-td v-if="item.tracking_state_id === 5 || item.tracking_state_id === 6">
              {{ FormatDate(item.end_date_actual) }}
            </vs-td>
            <vs-td v-else></vs-td>

            <vs-td v-if="item.shipment_status_id === 11">
              {{ FormatDate(item.end_date_actual) }}
            </vs-td>
            <vs-td v-else-if="item.shipment_status_id === 3">
              {{ FormatDate(item.updated_at) }}
            </vs-td>
            <vs-td v-else></vs-td>

            <vs-td>{{ item.pieces || 0 }}</vs-td>
            <vs-td>{{ item.weight || 0 }}</vs-td>
            <vs-td>
              <span v-if="item.total_discount_amount !== 0">{{ item.total_discount_amount }}{{$t('common.ກີບ')}}</span>
              <span v-if="item.total_discount_percent !== 0">{{ item.total_discount_percent }}%</span>
              <span v-if="item.total_discount_amount === 0 && item.total_discount_percent === 0">........</span>
            </vs-td>
            <vs-td>( {{ FormatPrice(item.sub_total_freight) }} )</vs-td>
            <vs-td>( {{ FormatPrice(item.total_insurance_price) }} )</vs-td>
            <vs-td :style="{color: 'crimson'}">( {{ FormatPrice(item.total_freight) }} )</vs-td>
            <vs-td :style="{color: 'crimson'}">( {{ FormatPrice(item.reject_freight) }} )</vs-td>
            <vs-td :style="{color: 'crimson'}">( {{ FormatPrice(item.total_rental_price) }} )</vs-td>
            <vs-td :style="{color: 'crimson'}">( {{ FormatPrice(item.total_price) }} )</vs-td>
            <vs-td>{{ item.sender_customer_name }}</vs-td>
            <vs-td>{{ item.receiver_customer_name }}</vs-td>
            <vs-td>{{ item.start_branch_name }}</vs-td>
            <vs-td>{{ item.end_branch_name }}</vs-td>
            <vs-td>
              <span v-if="item.shipment_pay_type === 'origin_freight_fees'">
                {{ $t("ລາຍການOrderພັດສະດຸ.ເກັບເງິນຕົ້ນທາງ") }}
              </span>
              <span v-if="item.shipment_pay_type === 'destination_freight_fees'">
                {{ $t("ລາຍການOrderພັດສະດຸ.ເກັບເງິນປາຍທາງ") }}
              </span>
              <span v-if="item.shipment_pay_type === 'origin_freight_fees_cod'">
                {{ $t("ລາຍການOrderພັດສະດຸ.ເກັບເງິນຕົ້ນທາງ ( COD )") }}
              </span>
              <span v-if="item.shipment_pay_type === 'destination_freight_fees_cod'">
                {{ $t("ລາຍການOrderພັດສະດຸ.ເກັບເງິນປາຍທາງ ( COD + CDC )") }}
              </span>
            </vs-td>
            <vs-td :style="{color: 'crimson'}">
              ( {{ item.shipment_type }} )
            </vs-td>
            <vs-td>{{ item.created_by_name }}</vs-td>

            <vs-td v-if="item.shipment_status_id === 3">{{ item.sign_name }}</vs-td>
            <vs-td v-else></vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <Pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset"
                      @paginate="FetchData"/>
          <Loading v-if="loading"/>
        </template>
      </vs-table>
      <vs-table v-else></vs-table>
    </div>
    <ModalEdit>
      <template v-slot="{ close }">
        <shipmentEdit @close="close"
                      :shipment_number="shipment_number"
                      :tab_query="$route.query.tab"
                      @success="FetchData()"/>
      </template>
    </ModalEdit>
    <ModalDelete>
      <template v-slot="{ close }">
        <shipmentBranch @close="close" :change_branch="change_branch" @success="FetchData()"/>
      </template>
    </ModalDelete>
    <ModalClose>
      <template v-slot="{ close }">
        <addCodPrice @close="close"
                     :shipment_number="shipment_number"
                     @success="FetchData()"/>
      </template>
    </ModalClose>
    <ModalPrint>
      <template v-slot="{ close }">
        <ChangeSender @close="close"
                      :shipment_number="shipment_number"
                      @success="FetchData()"/>
      </template>
    </ModalPrint>
    <ModalPreviewFile>
      <template v-slot="{ close }">
        <CancelAddressErrorOrder @close="close"
                                 :shipment_number="shipment_number"
                                 @success="FetchData()"/>
      </template>
    </ModalPreviewFile>
    <ModalCancel>
      <template v-slot="{ close }">
        <cancelSuccessOrder @close="close"
                            :shipment_number="shipment_number"
                            @success="FetchData()"/>
      </template>
    </ModalCancel>
    <ModalAdd>
      <template v-slot="{ close }">
        <CancelRejectOrder @close="close"
                           :shipment_number="shipment_number"
                           @success="FetchData()"/>
      </template>
    </ModalAdd>
    <vs-dialog v-model="showChangeRejectBranchModal" width="550px">
      <template #header>
        <h4 class="not-margin">
          <b>ປ່ຽນສາຂາຕີກັບ</b>
        </h4>
      </template>
      <ChangeRejectBranch
        :shipment_number="shipment_number"
        @close="showChangeRejectBranchModal = false"
        @success="handleChangeRejectBranchSuccess"/>
    </vs-dialog>
    <vs-dialog v-model="showUpdateBranchSwapModal" width="550px">
      <template #header>
        <h4 class="not-margin">
          <b>ຍົກເລີກມາກວດສອບການເຄື່ອນໄຫວ</b>
        </h4>
      </template>
      <UpdateBranchSwap
        :shipment_number="shipment_number"
        @close="showUpdateBranchSwapModal = false"
        @success="handleUpdateBranchSwapSuccess"/>
    </vs-dialog>
  </div>
</template>

<script>

import Loading from '../../Loading';
import Pagination from '@/Plugins/Paginations/Pagination';
import MixinBranchListOrders from '../../../Mixins/Accountings/Solve-Shipment';
import shipmentEdit from '@/views/Accounting/SolveShipments/Dialog/Edit'
import shipmentBranch from '@/views/Accounting/SolveShipments/Dialog/Delete'
import addCodPrice from '@/views/Accounting/SolveShipments/Dialog/AddCodPrice'
import cancelSuccessOrder from "@views/Accounting/SolveShipments/Dialog/CancelSuccessOrder";
import ChangeSender from "@views/Accounting/SolveShipments/Dialog/ChangeSender.vue";
import CancelAddressErrorOrder from "@views/Accounting/SolveShipments/Dialog/CancelAddressErrorOrder.vue";
import CancelRejectOrder from "@views/Accounting/SolveShipments/Dialog/CancelRejectOrder.vue";
import ChangeRejectBranch from "@views/Accounting/SolveShipments/Dialog/ChangeRejectBranch.vue";
import UpdateBranchSwap from "@views/Accounting/SolveShipments/Dialog/UpdateBranchSwap.vue";

export default {
  components: {
    Loading,
    Pagination,
    shipmentEdit,
    shipmentBranch,
    addCodPrice,
    cancelSuccessOrder,
    ChangeSender,
    CancelAddressErrorOrder,
    CancelRejectOrder,
    ChangeRejectBranch,
    UpdateBranchSwap
  },

  props: ['onclickEvent'],

  mixins: [MixinBranchListOrders],

  data() {
    return {
      // Pagination
      offset: 10,
      limit_page: 15,
      pagination: {
        current_page: 1,
        last_page: 1,
        total: 0,
        per_page: 15,
        from: 0,
        to: 0
      }
    };
  },

  methods: {
    // Fetch data with pagination support
    fetchInvoiceItemsResponse(page = null) {
      const currentPage = page || this.pagination.current_page;

      const params = {
        shipment_pay_type: this.$route.query.tab,
        query: this.searchItem,
        page: currentPage,
        per_page: this.limit_page,
      };

      return this.$axios.get('account/list/solve/shipments', { params })
    },

    // Handle pagination response - supports both paginated and single record
    FetchData(page = null) {
      this.loading = true;

      // Update current page if provided
      if (page !== null) {
        this.pagination.current_page = page;
      }

      this.fetchInvoiceItemsResponse(page).then((res) => {
        const responseData = res.data;

        // Check if response has Laravel pagination structure
        if (responseData && 'data' in responseData && Array.isArray(responseData.data) && 'last_page' in responseData) {
          // Paginated response (e.g., phone number search)
          this.listAllOrders = responseData.data;
          this.pagination = {
            current_page: parseInt(responseData.current_page) || 1,
            last_page: parseInt(responseData.last_page) || 1,
            total: parseInt(responseData.total) || 0,
            per_page: parseInt(responseData.per_page) || 15,
            from: parseInt(responseData.from) || 0,
            to: parseInt(responseData.to) || 0
          };
        } else if (responseData && typeof responseData === 'object' && responseData.id) {
          // Single shipment object (e.g., shipment number search)
          this.listAllOrders = [responseData];
          this.pagination = {
            current_page: 1,
            last_page: 1,
            total: 1,
            per_page: 1,
            from: 1,
            to: 1
          };
        } else if (Array.isArray(responseData)) {
          // Array of shipments (non-paginated)
          this.listAllOrders = responseData;
          this.pagination = {
            current_page: 1,
            last_page: 1,
            total: responseData.length,
            per_page: responseData.length,
            from: responseData.length > 0 ? 1 : 0,
            to: responseData.length
          };
        } else {
          // Unexpected format or empty
          this.listAllOrders = [];
          this.pagination = {
            current_page: 1,
            last_page: 1,
            total: 0,
            per_page: 15,
            from: 0,
            to: 0
          };
        }

        this.loading = false;
      }).catch((error) => {
        console.error('API Error:', error);
        this.loading = false;
        this.listAllOrders = [];
      });
    },

    OpenModalEdit(shipmentNumber) {
      this.shipment_number = JSON.parse(JSON.stringify(shipmentNumber));
      this.$store.commit("modalEdit_State", true);
    },

    OpenModalClose(shipmentNumber) {
      this.shipment_number = JSON.parse(JSON.stringify(shipmentNumber));
      this.$store.commit("modalClose_State", true);
    },

    OpenModalCancel(shipmentNumber) {
      this.shipment_number = JSON.parse(JSON.stringify(shipmentNumber));
      this.$store.commit("modalCancel_State", true);
    },

    OpenModalDelete(listAllOrders) {
      this.change_branch = JSON.parse(JSON.stringify(listAllOrders));
      this.$store.commit("modalDelete_State", true);
    },

    OpenModalPrint(shipmentNumber) {
      this.shipment_number = JSON.parse(JSON.stringify(shipmentNumber));
      this.$store.commit("modalPrint_State", true);
    },

    OpenModalPreviewFile(shipmentNumber) {
      this.shipment_number = JSON.parse(JSON.stringify(shipmentNumber));
      this.$store.commit("modalPreviewFile_State", true);
    },

    OpenModalAdd(shipmentNumber) {
      this.shipment_number = JSON.parse(JSON.stringify(shipmentNumber));
      this.$store.commit("modalAdd_State", true);
    },

    OpenModalChangeRejectBranch(shipmentNumber) {
      this.shipment_number = JSON.parse(JSON.stringify(shipmentNumber));
      this.showChangeRejectBranchModal = true;
    },

    handleChangeRejectBranchSuccess() {
      this.showChangeRejectBranchModal = false;
      this.FetchData();
    },

    OpenModalUpdateBranchSwap(shipmentNumber) {
      this.shipment_number = JSON.parse(JSON.stringify(shipmentNumber));
      this.showUpdateBranchSwapModal = true;
    },

    handleUpdateBranchSwapSuccess() {
      this.showUpdateBranchSwapModal = false;
      this.FetchData();
    },

    resetAndSearch() {
      // Reset to page 1 when searching
      this.pagination.current_page = 1;
      this.FetchData();
    }
  },

  computed: {
    getOrdersList() {
      return Array.isArray(this.listAllOrders) ? this.listAllOrders : [];
    }
  },

  watch: {
    'onclickEvent': function (value) {
      if (value !== '') {
        this.listAllOrders = [];
        this.searchItem = '';
        this.pagination.current_page = 1;
        this.FetchData();
      }
    }
  },

  created() {
    this.FetchData();
  }
}
</script>

<style lang="scss">
.btn-clear {
  background: $crimson;

  &:hover {
    color: $white;
  }
}

.vs-select__input {
  width: 55% !important;
  margin-left: -163px !important;
  border-radius: 5px !important;
  background: $white !important;
  border: 1px solid rgba(173, 172, 172, 0.562) !important;
}

.table-limit-height {
  .vs-table {
    width: 100%;
    font-size: 0.9rem;
    margin: 0;
    max-height: 500px;
  }
}

</style>
